import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, ButtonGroup, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import Calendar from 'assets/icon/calendar-icon.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import { Field, Formik } from 'formik';
import ReactSelect from 'react-select';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import useContextService from 'hooks/useContextService';
import useAxios from 'hooks/useAxios';
import { cloneDeep, find } from "lodash";
import { Option, LimitedChipsContainer } from 'components/Options';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import FormikInputField from "components/common/Fields/FormikInputField";

import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import Loader from 'components/Loader';

let hasDatePopupOpen = false;

let tableDataBackup = [
  // {
  //     chainPharmacy:"123445",
  //     pharmacy:"123445",
  //     npi:"123445",
  //     ncpdPandNABP:"123445",
  //     pharmacyAddress:"123445",
  //     pharmacyLiveDate:"123445",
  //     pharmacyTerminationDate:"123445",
  //     claimsProcessDate:"123445",

  // }
];
let rowForEdit = {};
let updatedFields = {};
let coveredEntityError = "Covered Entity is a required field";
let accumulationError = "Accumulator is a required field";

let coveredEntitiesData = [];
let accumulationData = [];
let orderStatusData = [];
let accountTypeData = [];
const SearchContainer = (props) => {
    const { orgId, manvalPharmacy,setLoading, onReset,onSearch, reset,tabKey } = props;

  const [tableData, setTableData] = useState(tableDataBackup);
  const [data, setData] = useState(tableDataBackup);
  const [showDetails, setShowDetails] = useState(true)
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [activeButton, setActiveButton] = useState("Left");
  const [isSubmited, serIsSubmitted] = useState(false);

  const [hasACCSelected, setACCSelected] = useState(true);
  const [hasCESelected, setCESelected] = useState(true);
  const [accuDisabled, setAccuDisabled] = useState(false)
  const [selectedCEOption, setCEOptionSelected] = useState({
    optionCESelected: "-1",
  });
  const [selectedACCOption, setOptionACCSelected] = useState({
    optionACCSelected: "-1",
  });
  const [orderStatus, setOrderStatus] = useState([]);
  const [selectedOrderStatus, setOrderStatusSelected] = useState();
  const [accountType, setAccountType] = useState([]);
  const [selectedAccountType, setAccountTypeSelected] = useState();
  const [poNum, setPONumber] = useState('');
  const API = useAxios();

  const {
    states: { poReconciliation },
    setStates,
    resetStates,
  } = useContextService();
  const { coveredEntity, searchTerms, accumulations } = poReconciliation
  let {
    coveredEntityIDs,
    coveredEntityID,
    accumulationIDs,
    orderStatusId,
    poNumber,
    accountTypeId,
  } = searchTerms;
  const updateStates = (poReconciliation) => {
    setStates("poReconciliation", poReconciliation);
  };
  useEffect(() => {
    fetchAccountType();
    fetchOrderStatus();
  }, []);

  useEffect(() => {

    setCESelected(true);
    setACCSelected(true);
    coveredEntitiesData = [];
    accumulationData = [];
    poReconciliation.searchTerms.coveredEntityIDs = {};
    poReconciliation.searchTerms.accumulationIDs = {};
    setAccuDisabled(false);
    poReconciliation.accumulations = [];
    updateStates(poReconciliation);
    setCEOptionSelected({ optionCESelected: '-1' });
    setOptionACCSelected({ optionACCSelected: '-1' });
    setAccountTypeSelected('');
    setOrderStatusSelected('');
    setPONumber('');
    fetchCoveredEntities();
    serIsSubmitted(false);


  }, [orgId, reset]);

  const fetchCoveredEntities = async () => {
    debugger
    //let { organizationID } = orgId; 
    if(tabKey !== "poreconciliation") return null;
    if (typeof orgId !== "undefined" && orgId !== null) {
      coveredEntitiesData = [];
      poReconciliation.searchTerms.coveredEntityIDs = {};
      updateStates(poReconciliation);

      let selectedOrgId = orgId.organizationID;
       setLoading(true);
      try {
        const { data } = await API.get(
          `SBConfig/coveredentity/list/${selectedOrgId}`,
          {
            hasDefaultURL: true,
          }
        );
        if (data) {
          for (var x in data) {
            coveredEntitiesData.push({
              value: data[x].coveredEntityID,
              label: data[x].coveredEntityName,
            });
          }
          poReconciliation.coveredEntities = data;
          if (coveredEntitiesData.length == 1) {
            var ceData = [];
            ceData.push(coveredEntitiesData[0]);
            poReconciliation.searchTerms.coveredEntityIDs = ceData;
            window.selectedCoveredEntittyId = ceData;
          }
          if (window.selectedCoveredEntittyId.length > 0) {
            poReconciliation.searchTerms.coveredEntityIDs =
              window.selectedCoveredEntittyId;
          }
setLoading(false);
          updateStates(poReconciliation);
          if (poReconciliation.searchTerms.coveredEntityIDs) {
            var ceSelected = [];
            ceSelected.optionCESelected = [];
            for (var x in poReconciliation.searchTerms.coveredEntityIDs) {
              ceSelected.optionCESelected.push(
                poReconciliation.searchTerms.coveredEntityIDs[x]
              );
            }
            setCEOptionSelected(ceSelected);
            let ceIds = poReconciliation.searchTerms.coveredEntityIDs.map(
              (item) => item["value"]
            );
            fetchAccumulationName(ceIds);
          }
        }
         setLoading(false);
      } catch (err) {
         setLoading(false);
      }
    }
  };
  const handleCoverdEntityChange = (selectedces, setFieldValue, entity) => {
    let selected = [selectedces == null ? [] : selectedces]
    if (selected) {
      window.selectedCoveredEntittyId = selected;
      window.selectedAccumulatorId = [];
      accumulationData = [];
      // setSelectedNdc('');
      poReconciliation.searchTerms.accumulationIDs = {};
      setCESelected(true);
      setCEOptionSelected({
        optionCESelected: selected.value
      });
      let val = selected.value;
      poReconciliation.coveredEntities = selected;
      setFieldValue('coveredEntityIDs', selected);
      poReconciliation.searchTerms.coveredEntityIDs = selected;
      if (Array.isArray(poReconciliation.searchTerms.coveredEntityIDs)) {
        accumulationIDs = {};
        poReconciliation.searchTerms.accumulationIDs = {};
      }
      let ceIds = poReconciliation.searchTerms.coveredEntityIDs.map(item => item["value"]);
      poReconciliation.searchTerms.coveredEntityIDs = ceIds;
      updateStates(poReconciliation);
      setAccuDisabled(false);
      fetchAccumulationName(ceIds);
      setOptionACCSelected({ optionACCSelected: '-1' });
    }
    else {
      setFieldValue('coveredEntityIDs', {});
      accumulationData = [];
      poReconciliation.coveredEntities = [];
      poReconciliation.searchTerms.coveredEntityIDs = {};
      poReconciliation.searchTerms.accumulationIDs = {};
      setCESelected(false);
      setACCSelected(false);
    }
     onReset()
    updateStates(poReconciliation);
  };
  const fetchAccumulationName = async (coveredEntityIDs) => {
   debugger
    if (coveredEntityIDs !== undefined && coveredEntityIDs.length > 0) {
      try {
        accumulationData = [];
        const payload = [];
        payload.AccumulatorEntityList = [coveredEntityIDs[0]];
        let AccumulatorEntityList = [payload.AccumulatorEntityList]
        const result = await API.get(`SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
          {
            hasDefaultURL: true,
          }
        );
        if (result) {
          let accumulator = []
          accumulator = result.data;
          for (var x in accumulator) {
            accumulationData.push({ "value": accumulator[x].accumulatorID, "label": accumulator[x].ceName });
          }

          if (accumulationData.length == 1) {
            handleAccumulatorname(accumulationData[0]);
          }
          // else if (window.selectedAccumulatorId.length > 0) {
          //   poReconciliation.searchTerms.accumulationIDs =
          //     window.selectedAccumulatorId;
          //     handleAccumulatorname(window.selectedAccumulatorId[0]);
          // }
          poReconciliation.accumulations = result.data;
          updateStates(poReconciliation);
          // if (accumulationIDs.length > 0) {
          //     var accumulatorSelected = {};
          //     accumulatorSelected.optionACCSelected = [];

          //     for (var x in accumulationIDs) {
          //         accumulatorSelected.optionACCSelected.push(accumulationIDs[x]);
          //     }
          //     setOptionACCSelected({ accumulatorSelected});
          // }
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  const handleAccumulatorname = (selectedces, setFieldValue, ac) => {
    debugger
    let selected = [selectedces == null ? [] : selectedces]
    if (selected) {
      window.selectedAccumulatorId = selected;
      setACCSelected(true);
      setOptionACCSelected({
        optionACCSelected: selected
      })
      setAccuDisabled(true);
      // let val = selected.value;
      // setFieldValue('accumulatorID', val);
      // setFieldValue('accumulationIDs', selected);
      poReconciliation.searchTerms.accumulationIDs = selected;
      handleSubmit();

    }
    else {
      setACCSelected(true);
      setFieldValue('accumulationIDs', {});
      accumulationData = [];
      poReconciliation.coveredEntities = [];
      poReconciliation.searchTerms.accumulationIDs = {};
      poReconciliation.searchTerms.coveredEntityIDs = {};
      setCESelected(false);
    }
    updateStates(poReconciliation);
  };
  const fetchAccountType = async () => {
    accountTypeData = []
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/accountType`, { hasDefaultURL: true });
      console.log(data, "Account Type Data")
      if (data) {

        for (var x in data) {
          accountTypeData.push({ "id": data[x].id, "description": data[x].description })
        }
        if (accountTypeId) {
          poReconciliation.searchTerms.accountTypeId = accountTypeId;
          updateStates(poReconciliation);
        }
        setAccountType(data);
      }
      else {
        setAccountType([]);
      }

    }

    catch (err) {

    }
  }
  const handleAccountTypeChange = (e, setFieldValue) => {

    const { value } = e.target;
    setFieldValue('accountTypeId', value);
    setAccountTypeSelected(value);
    poReconciliation.searchTerms.accountTypeId = value;
    updateStates(poReconciliation);
    // console.log(value,"Account")
  };
  const fetchOrderStatus = async () => {
    orderStatusData = []
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/poorderstatus`, { hasDefaultURL: true });     
      if (data) {
        for (var x in data) {
          orderStatusData.push({ "id": data[x].id, "description": data[x].description })
        }
        if (orderStatusId) {
          poReconciliation.searchTerms.orderStatus = orderStatusId;
          updateStates(poReconciliation);
        }
        setOrderStatus(data);
      }
      else {
        setOrderStatus([]);
      }

    }
    catch (err) {

    }
  }
  const handleOrderStatusChange = (e, setFieldValue) => {

    const { value } = e.target;
    setFieldValue('orderStatusId', value);
    setOrderStatusSelected(value);
    poReconciliation.searchTerms.orderStatusId = value;
    updateStates(poReconciliation);
  };
  const handlePONUmberOnChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue('poNumber', value);
    setPONumber(value);
    poReconciliation.searchTerms.poNumber = value;
    updateStates(poReconciliation);
  };




  const handleSubmit = async () => {

    // serIsSubmitted(true);
    // const { setSubmitting } = actions;
    let acIDs = [];
    let ceIDs = [];
    //let phIDs = [];

    // if (searchTerms.coveredEntityIDs.length > 0) {
    //   val.coveredEntityIDs = searchTerms.coveredEntityIDs;
    //   setCESelected(true);
    // }
    // if (searchTerms.accumulationIDs.length > 0) {
    //     val.accumulationIDs = searchTerms.accumulationIDs;
    //     setACCSelected(true);
    //   }

    for (var x in searchTerms.accumulationIDs) {
      var rw = searchTerms.accumulationIDs[x];
      acIDs.push(rw.value);
    }
    for (var x in searchTerms.coveredEntityIDs) {
      var rw = searchTerms.coveredEntityIDs[x];
      ceIDs.push(rw.value);
    }
    // for (var x in val.pharmacyIds) {
    //   var rw = val.pharmacyIds[x];
    //   phIDs.push(rw.value);
    // }

    if (ceIDs.length == 0) {
      console.log(ceIDs, "ceIDsa")
      setCESelected(false);

      //  return setSubmitting(false);
    }
    if (acIDs.length == 0) {
      setACCSelected(false);

    }

    //  const values = cloneDeep(val);
    const values = {}

    //   if (ceIDs > [0]) values.coveredEntityIDs = val.coveredEntityIDs;
    if (ceIDs > [0]) values.CoveredEntityIDs = ceIDs;
    if (acIDs > [0]) values.accumulationIDs = acIDs;
    if (poNumber) values.poNumber = poNumber;

    if (selectedOrderStatus) {
      values.orderStatusId = selectedOrderStatus;
    }
    else {
      values.orderStatusId = 0;
    }
    if (selectedAccountType) {
      values.accountTypeId = selectedAccountType;
    }
    else {
      values.accountTypeId = 0;
    }
    values.Poid = poNum;
    poReconciliation.search.currentPage = 1;
    updateStates(poReconciliation);
    await onSearch(values);
    // setSubmitting(false);
  };

  const handleReset = ({ resetForm }) => {
    serIsSubmitted(false);
    setCESelected(true);
    setAccuDisabled(false)
    setACCSelected(true);
    setAccountTypeSelected('');
    setOrderStatusSelected('');
    setPONumber('');
    accumulationData = [];
    window.selectedCoveredEntittyId = "";
    window.selectedAccumulatorId = "";
    onReset();
    resetForm();
    setCEOptionSelected({ optionCESelected: "-1" });
    setOptionACCSelected({ optionACCSelected: "-1" });

    poReconciliation.searchTerms.coveredEntityIDs = {};
    poReconciliation.searchTerms.accumulationIDs = {};
    updateStates(poReconciliation);
    resetStates("poReconciliation");

  }


  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    }
    else {
      setCollIcon(faAngleUp);
    }
  }


  const renderEditButton = () => {
    // if (hasPermission('EDT'))
    return <Button
      className='text-primary p-0 text-decoration-none'
      color='link'
      onClick={() => ""}
      title='Edit Covered Entity'

    >
      <HoverImage src={EditIcon}
        hoverSrc={EditHoverIcon}
        alt='' />
    </Button>
  }
  const cellRenderEdit = (rowData) => {

    if (rowData.isEdit) {
      return (
        <div className='d-flex align-items-center'>
          <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={savePanelUpdateRow}
          >
            <HoverImage
              key='SaveIcon'
              src={SaveIcon}
              hoverSrc={SaveHoverIcon}
              alt=''
            />
          </Button>
          <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => editRow(rowData, false)}
          >
            <HoverImage
              key='CancelIcon'
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt=''
            />
          </Button>
        </div>
      );
    } else {

      return (
        <div className='d-flex align-items-center'>
          {renderEditLButton1(rowData)}

        </div>
      );
    }
  };
  const renderEditLButton1 = (rowData) => {
    // if (hasPermission('EPLS'))
    return <Button
      className='text-primary p-0 text-decoration-none'
      color='link'

      onClick={() => editRow(rowData)}
      title='Edit'


    >
      <HoverImage src={EditIcon}
        hoverSrc={EditHoverIcon}
        alt='' />
    </Button>
  }
  const editRow = (rowData, isEdit = true) => {

    let tempData = [...data];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    // setTouched('');
    // setSelectedStatus('');
    updatedFields = {};
    //  tableDataBackup = tempData;
    setData(tempData);
  };
  const savePanelUpdateRow = async () => {
    console.log("krishna")
  };
  const updateRowValue = (value, col) => {

    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };
  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {

    return (
      <CellEditRender
        row={row}
        col={col}
        formatterType={formatterType}
        onChange={updateRowValue}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
      />
    );
  };

  const handelAdd = () => {
    setShowDetails(false)
  }
  const handelCancel = () => {
    setShowDetails(true)
  }
  useEffect(() => {

  }, [showDetails])
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {

    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };
  return (

    <div>
      <h5 className="f-16 text-primary font-weight-700">
        Search  PO Reconciliation
      </h5>


      <Formik
        initialValues={searchTerms}
        onSubmit={handleSubmit}
        // validationSchema={validationSchema}
        // enableReinitialize={true}
        children={(props) => {
          const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
          return (
            <div hidden={collapseSider}>
              <div>
                <Row sm={5} className="d-flex" style={{}}>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="coveredentity">
                        Covered Entity
                      </Label>
                      <ReactSelect
                        name="coveredentity"
                        id="coveredentity"
                        // className="required"
                        options={coveredEntitiesData}
                        // closeMenuOnSelect={false}
                        // isClearable ={true}
                        // hideSelectedOptions={false}
                        // optionSelected={true}
                        //isMulti
                        components={{
                          Option
                        }}
                        isSearchable="true"
                        onChange={(value, entity) =>
                          handleCoverdEntityChange(
                            value,
                            setFieldValue,
                            entity
                          )
                        }
                        value={
                          selectedCEOption.optionCESelected
                        }
                        className="claim_info required"
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                            ...provided,
                            display: "flex",
                            alignItems: "flex-start",
                          }),
                        }}
                      />
                      {!hasCESelected ? (
                        <div className="text-danger f-12 position-absolute">
                          {coveredEntityError}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="accumulator">
                        Accumulator
                      </Label>
                      <ReactSelect
                        name="accumulator"
                        id="accumulator"
                        isDisabled={accumulationData.length == 1}
                        options={accumulationData}
                        //isMulti
                        // closeMenuOnSelect={false}
                        // isClearable ={true}
                        // hideSelectedOptions={false}
                        // optionSelected={true}
                        components={{
                          Option
                        }}
                        isSearchable="true"
                        onChange={(value, ac) =>
                          handleAccumulatorname(
                            value,
                            setFieldValue,
                            ac
                          )
                        }
                        value={
                          selectedACCOption.optionACCSelected
                        }
                        className="claim_info required"
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                            ...provided,
                            display: "flex",
                            alignItems: "flex-start",
                          }),
                        }}
                      />
                      {/* {(!hasACCSelected && isSubmited) ||
                                            (hasCESelected &&
                                              isSubmited &&
                                              selectedACCOption.optionACCSelected ==
                                                "-1") ? (
                                              <div className="text-danger f-12 position-absolute">
                                                {accumulationError}
                                              </div>
                                            ) : null} */}
                      {!hasACCSelected ? (
                        <div className="text-danger f-12 position-absolute">
                          {accumulationError}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  {/* <Col md={3} lg={3} sm={6} xs={6}>
                                          {" "}
                                          <FormGroup>
                                            <Label for="hospitalName">
                                              Hospital Name
                                            </Label>
                                            <ReactSelect
                                              name="hospitalName"
                                              id="hospitalName"
                                           
                                              options={accumulationData}
                                              //isMulti
                                              // closeMenuOnSelect={false}
                                              // isClearable ={true}
                                              // hideSelectedOptions={false}
                                              // optionSelected={true}
                                              components={{
                                                Option
                                              }}
                                              isSearchable="true"
                                              onChange={(value, ac) =>
                                                handleAccumulatorname(
                                                  value,
                                                  setFieldValue,
                                                  ac
                                                )
                                              }
                                              value={
                                                selectedACCOption.optionACCSelected
                                              }
                                              className="claim_info required"
                                              maxMenuHeight={220}
                                              styles={{
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 99,
                                                }),
                                              }}
                                            />
                                            {(!hasACCSelected && isSubmited) ||
                                            (hasCESelected &&
                                              isSubmited &&
                                              selectedACCOption.optionACCSelected ==
                                                "-1") ? (
                                              <div className="text-danger f-12 position-absolute">
                                                {accumulationError}
                                              </div>
                                            ) : null}
                                          </FormGroup>
                                        </Col> */}
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="accounttype">
                        Account Type
                      </Label>
                      <Input
                        // className="required"
                        name="accounttype"
                        id="accounttype"
                        type="select"
                        value={selectedAccountType}
                        component={FormikSelectField}
                        onChange={(e) =>
                          handleAccountTypeChange(
                            e,
                            setFieldValue
                          )
                        }
                      >
                        <option value={""}>(All)</option>
                        {accountTypeData.map(
                          (accountT) => {
                            const { id, description } =
                              accountT;
                            return (
                              <option key={id} value={id}>
                                {description}
                              </option>
                            );
                          }
                        )}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="status">
                        Order Status
                      </Label>
                      <Input
                        // className="required"
                        name="orderStatus"
                        id="orderStatus"
                        type="select"
                        value={selectedOrderStatus}
                        component={FormikSelectField}
                        onChange={(e) =>
                          handleOrderStatusChange(
                            e,
                            setFieldValue
                          )
                        }
                      >
                        <option value={""}>(All)</option>
                        {orderStatusData.map((status) => {
                          const { id, description } =
                            status;
                          return (
                            <option key={id} value={id}>
                              {description}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="purchaseorder">
                        Purchase Order
                      </Label>
                      <Input
                        id="purchaseorder"
                        name="purchaseorder"
                        type="text"
                        placeholder="Enter PO Number"
                        autoComplete="off"
                        value={poNum}
                        component={FormikInputField}
                        // className="required"
                        onChange={(e) => {
                          handlePONUmberOnChange(
                            e,
                            setFieldValue
                          );
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <div hidden={""}>
                <Row className="d-flex" style={{ justifyContent: "flex-end" }}>
                  <Col md="auto" className="">
                    <Label>{""}</Label>
                    <Button
                      // hidden={isAddPermission}
                      // disabled={isSubmitting}
                      color="primary"
                      className="search ms-3"
                      onClick={handleSubmit}

                    // disabled={!coveredEntityid}
                    // hidden={!hasPermission("ADD")}
                    >
                      <span className="right_5"><img src={search} alt="" /></span> Search
                    </Button>
                    <Button
                      // hidden={isAddPermission}
                      // disabled={isSubmitting}
                      color="primary"
                      className="reset"
                      // onClick={handleReset}
                      onClick={() => handleReset(props)}
                    // disabled={!coveredEntityid}
                    // hidden={!hasPermission("ADD")}
                    >
                      <span className="right_5"><img src={reseticon} alt="" /></span> Reset
                    </Button>
                  </Col>
                </Row>
              </div>

              {/* <hr /> */}
            </div>
          );
        }}></Formik>
      {/* <div className="py-2 text-center">
                            <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                                <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                            </span>
                        </div> */}


    </div>
  )
}

export default SearchContainer
